"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboundBookingResponseUnits = exports.InboundBookingCargoTotalUnit = void 0;
var InboundBookingCargoTotalUnit;
(function (InboundBookingCargoTotalUnit) {
    InboundBookingCargoTotalUnit["CFT_LB"] = "CFT_LB";
    InboundBookingCargoTotalUnit["CBM_KG"] = "CBM_KG";
})(InboundBookingCargoTotalUnit = exports.InboundBookingCargoTotalUnit || (exports.InboundBookingCargoTotalUnit = {}));
var InboundBookingResponseUnits;
(function (InboundBookingResponseUnits) {
    InboundBookingResponseUnits["KG"] = "KG";
    InboundBookingResponseUnits["LB"] = "LB";
    InboundBookingResponseUnits["PALLETS"] = "PALLETS";
    InboundBookingResponseUnits["CASES"] = "CASES";
    InboundBookingResponseUnits["UNITS"] = "UNITS";
    InboundBookingResponseUnits["LTL"] = "LTL";
    InboundBookingResponseUnits["FTL"] = "FTL";
})(InboundBookingResponseUnits = exports.InboundBookingResponseUnits || (exports.InboundBookingResponseUnits = {}));
//# sourceMappingURL=InboundBookingUnit.js.map